<template>
  <v-autocomplete :items="itemsAreas" :item-text="itemText" :item-value="itemValue" :label="label" :dense="dense"
    :solo="solo" :flat="flat" :chips="chips" :outlined="outlined" :background-color="backgroundColor" v-model="areaId"
    :loading="loading" :disabled="disabled" :required="required" :no-data-text="noDataText" @input="input"
    :multiple="multiple" :rules="rules" :clearable="clearable" :messages="messages" v-bind="$attrs">
    <template v-slot:selection="{ props, item, index }">
      <template v-if="chipType == 'text'">
        <v-chip v-bind="props" closable :close="multiple" @click:close="areaId.splice(index, 1)"
          :class="`selection-chip chip-text ${item.statusBooking.color}`"
          :color="item.statusBooking ? item.statusBooking.color : 'gray'">
          <img v-if="item.statusBooking && item.statusBooking.svgUrl" :src="item.statusBooking.svgUrl" />
          <div class="list-area-in">
            <div class="title-business-name" v-if="item.statusBooking && !item.statusBooking.isAvailable">{{
              item.statusBooking ? item.statusBooking.businessName : '-' }}</div>
            <div class="flex-row">
              <div class="title-area">{{ item.statusBooking ? item.statusBooking.title : '' }}</div>
              <div class="sub-title-area">{{ item.statusBooking ? item.statusBooking.subTitle : '' }}</div>
            </div>
          </div>
        </v-chip>
      </template>
      <template v-else>
        <v-chip v-bind="props" closable :close="multiple" @click:close="areaId.splice(index, 1)"
          :color="item.statusBooking ? item.statusBooking.color : 'gray'" class="selection-chip white--text">
          <img v-if="item.statusBooking && item.statusBooking.svgUrl" :src="item.statusBooking.svgUrl" />
          <div class="list-area-in">
            <div class="title-business-name" v-if="item.statusBooking && !item.statusBooking.isAvailable">{{
              item.statusBooking ? item.statusBooking.businessName : '-' }}</div>
            <div class="flex-row">
              <div class="title-area">{{ item.statusBooking ? item.statusBooking.title : '' }}</div>
              <div class="sub-title-area">{{ item.statusBooking ? item.statusBooking.subTitle : '' }}</div>
            </div>
          </div>
        </v-chip>
      </template>
    </template>
    <template v-slot:item="{ props, item, selected }">
      <div v-bind="props" :class="`list-area  font-${item.statusBooking.color}`">
        <img v-if="item.statusBooking && item.statusBooking.svgUrl" :src="item.statusBooking.svgUrl" />
        <div class="list-area-in">
          <div class="title-business-name" v-if="item.statusBooking && !item.statusBooking.isAvailable">{{
            item.statusBooking ? item.statusBooking.businessName : '-' }}</div>
          <div class="flex-row">
            <div class="title-area">{{ item.statusBooking ? item.statusBooking.title : '' }}</div>
            <div class="sub-title-area">{{ item.statusBooking ? item.statusBooking.subTitle : '' }}</div>
          </div>
        </div>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AutocompleteArea",
  computed: {
    ...mapGetters({
      getAreas: "markets/getAreas"
    }),
    itemsAreas() {
      let areas = null;
      if (this.items != undefined && this.items && this.items.length > 0) {
        areas = this.items.filter(this.filter);
      } else {
        areas = [];
      }
      return areas;
    },
    areaId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  data() {
    return {
    };
  },
  props: {
    value: [String, Object, Array],
    input: Function,
    items: Array,
    rules: {
      default: () => [],
      type: Array
    },
    itemText: {
      default: area => area.name,
      type: Function
    },
    itemValue: {
      default: area => area.objectId,
      type: Function
    },
    label: {
      default: function () {
        return this.$t('area.add_to_stall')
      },
      type: String
    },
    backgroundColor: {
      default: "",
      type: String
    },
    noDataText: {
      default: "",
      type: String
    },
    chips: {
      default: false,
      type: Boolean
    },
    dense: {
      default: false,
      type: Boolean
    },
    solo: {
      default: false,
      type: Boolean
    },
    flat: {
      default: false,
      type: Boolean
    },
    outlined: {
      default: false,
      type: Boolean
    },
    multiple: {
      default: false,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    },
    filterArea: {
      default: 'All',
      type: String
    },
    messages: {
      default: '',
      type: String
    },
    chipType: String,
    isHideIcon: {
      default: false,
      type: Boolean
    },
    clearable: {
      default: true,
      type: Boolean
    }
  },
  methods: {
    filter(item) {
      let res = false
      if (!this.filterArea || this.filterArea == 'All') {
        res = true
      } else if (this.filterArea == 'isAvailable') {
        if (item.statusBooking && item.statusBooking.isAvailable)
          res = true
      } else if (this.filterArea == 'isSuspend') {
        if (item.statusBooking && item.statusBooking.isSuspend)
          res = true
      } else if (this.filterArea == 'isOutContract') {
        if (item.statusBooking && item.statusBooking.isOutContract)
          res = true
      } else if (this.filterArea == 'isInContract') {
        if (item.statusBooking && item.statusBooking.isInContract)
          res = true
      } else if (this.filterArea == 'isCloseContract') {
        if (item.statusBooking && item.statusBooking.isCloseContract)
          res = true
      } else {
        res = false
      }
      return res
    },
    checkExpired(date) {
      let isExpired = false;
      if (date && date.iso) {
        isExpired = this.$moment().isAfter(this.$moment(date.iso));
      } else if (date) {
        isExpired = this.$moment().isAfter(this.$moment(date));
      }
      return isExpired;
    },
    dateFormat(date, format = "YYYY-MM-DD", outFormat = "DD MMM YYYY HH:mm") {
      let res = "";
      if (date) {
        res = this.$moment(date, format).format(outFormat);
      }
      return res;
    },
  }
};
</script>

<style lang="scss" scoped>
.v-chip {
  height: 100%;
}

.list-area {
  font-size: 17px;
  // border-bottom: 1px solid rgba(104, 104, 104, 0.281);
  display: flex;
  align-items: center;

  i,
  img {
    margin-right: 10px;
    font-size: 22px !important;
  }

  img {
    min-width: 45px;
    width: auto;
    height: 100%;
    max-height: 50px;
    max-width: 50px;
  }

  .list-area-in {
    display: flex;
    align-items: center;
    justify-content: center;
    align-items: baseline;
    flex-direction: column;
    // gap: 5px;
    margin-right: 5px;
    padding: 10px 0;

    .title-business-name {
      font-weight: bold;
      font-size: 16px;
    }

    .flex-row {
      display: flex;
      flex-direction: row;
      gap: 5px;
    }
  }

  .title-area {
    // margin-right: 5px;
  }

  .sub-title-area {
    font-size: 16px;
  }
}

.list-area.font-error {
  color: var(--v-error-base);
}

.list-area.font-info {
  color: var(--v-info-base);
}

.list-area.font-warning {
  color: var(--v-warning-base);
}

.list-area.font-success {
  color: var(--v-success-base);
}

.selection-chip {
  font-size: 17px;
  display: flex;
  align-items: center;
  padding: 15px 20px;
  i,
  img {
    margin-right: 10px;
    font-size: 22px !important;
  }

  img {
    min-width: 45px;
    width: auto;
    height: 100%;
    max-height: 50px;
    max-width: 50px;
  }

  .list-area-in {
    display: flex;
    align-items: center;
    justify-content: center;
    align-items: baseline;
    flex-direction: column;
    gap: 5px;
    margin-right: 5px;

    .title-business-name {
      font-weight: bold;
      color: #fff !important;
    }

    .title-area, .sub-title-area{
      color: #fff !important;
    }

    .flex-row {
      display: flex;
      flex-direction: row;
      gap: 5px;
    }
  }

  .title-area {
    // margin-right: 5px;
  }

  .sub-title-area {
    font-size: 16px;
  }
}

.list-area {
  display: flex;
}

.list-area .title-business-name.font-error,
.list-area .title-area.font-error,
.list-area .sub-title-area.font-error {
  color: var(--v-error-base);
}

.list-area .title-business-name.font-info,
.list-area .title-area.font-info,
.list-area .sub-title-area.font-info {
  color: var(--v-info-base);
}

.list-area .title-business-name.font-warning,
.list-area .title-area.font-warning,
.list-area .sub-title-area.font-warning {
  color: var(--v-warning-base);
}

.list-area .title-business-name.font-success,
.list-area .title-area.font-success,
.list-area .sub-title-area.font-success {
  color: var(--v-success-base);
}
</style>
